module.exports = "/assets/data/b1b1f1298cb80fb83298110d32667105-DD2.data.json";